import { render, staticRenderFns } from "./CadastroUsuario.vue?vue&type=template&id=a1b2912c&"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js&"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CadastroUsuario.vue?vue&type=style&index=0&id=a1b2912c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports